import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';

import { OutlinedRightArrowIcon } from '@shared/assets-icon';
import type { GenderType } from '@shared/constants/constants';
import { getDefaultProfilePicDisplay, getProfilePictureS3ImageDisplay } from '@shared/utils/profile';

const { Text } = Typography;

interface ProfileItemProps {
  age?: null | number;
  className?: string;
  gender?: GenderType;
  name: string;
  onClick: () => void;
  photo: null | string;
}

const ProfileItem = ({ age, className, gender, name, onClick, photo }: ProfileItemProps) => (
  <button
    aria-label={`Switch profile to ${name}`}
    className={twClassMerge(
      'flex gap-5 rounded-2xl border border-functional-stone bg-white p-4 text-start cursor-pointer items-center',
      className
    )}
    onClick={onClick}
  >
    <img
      alt=""
      className={twClassMerge('gbomit size-12px rounded-[14px] object-cover ')}
      onError={(e) => {
        e.currentTarget.src = getDefaultProfilePicDisplay(null, null);
      }}
      src={getProfilePictureS3ImageDisplay(photo ?? '', gender, age)}
    />
    <div className="flex flex-1 flex-col justify-center">
      <Text className="gbmask mb-0 text-sm font-semibold">{name}</Text>
    </div>
    <OutlinedRightArrowIcon className="size-6px shrink-0" />
  </button>
);

export default ProfileItem;
